import { RectTube } from '@App/app/entities/layer/rect-tube.model';
import { Component } from '@angular/core';
import { RectLayerPropertiesComponent } from '../rect-layer-properties/rect-layer-properties.component';

@Component({
  selector: 'app-rect-tube-properties',
  templateUrl: './rect-tube-properties.component.html',
})
export class RectTubePropertiesComponent extends RectLayerPropertiesComponent<RectTube> {}
